import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import { parseTag, parseTags } from '@/shared/converters/tagConverters';
import User from '@/shared/models/User';
import JobType from '../constants/JobType';
import JobMaster, { LinkedJob } from '../models/JobMaster';
import { parseCheckListDetails, parseSeverity, parseWarrantyStatus } from './jobConverters';

export const LINKED_JOB_SCHEMA = {
  id: 'id',
  description: 'description',
  sequenceNumber: 'sequenceNr',
};

const SCHEMA = {
  id: 'id',
  createdOn: (data: any) => parseMoment(data.createdOn),
  type: parseType,
  sequenceNumber: 'sequenceNr',
  description: 'description',
  needFollowUp: 'isFollowUpAppointmentRequired',
  workStatus: 'workStatus',
  executionStatus: 'executionStatus',
  orderStatus: 'orderStatus',
  hasOrderSignature: 'hasOrderSignature',
  priceApprovalStatus: 'priceApprovalStatus',
  warranty: (data: any) => parseWarrantyStatus(data.priceType),
  pauseReason: (data: any) => parseTag(data.pauseReason, { isPause: true }),
  tags: (data: any) => parseTags(data.tags),
  mediaCount: 'mediaCount',
  commentCount: 'commentCount',
  diagnosticCount: 'diagnosticsCount',
  checklistDetails: (data: any) => parseCheckListDetails(data.checklistDetails),
  assignedTo: (data: any) => User.withId(data.assignedToId),
  severity: parseSeverity,
  checklistStatus: 'checklistStatus',
  linkedJob: parseLinkedJob,
};

function parseType(data: any): JobType {
  // WORKAROUND backends sends COMMENT instead of NOTE in push messages
  return data.type === 'COMMENT' ? JobType.COMMENT : data.type;
}

function parseLinkedJob(data: any): LinkedJob | null {
  return parseEntity(data.linkedJob, LINKED_JOB_SCHEMA, LinkedJob);
}

export function parseJobMaster(data: any): JobMaster | null {
  return parseEntity(data, SCHEMA, JobMaster);
}

export function parseJobMasters(data: any): Array<JobMaster> {
  return parseEntities(data, SCHEMA, JobMaster);
}